import {
  Board,
  BoardSearchResult,
  ColSpan2,
  ColTitle,
  Input,
  RelativeDiv,
  ResetButton,
  RowSpan,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {VerticalRule} from "../../components/common/Common";
import {Row} from "../campaign/styles/common";
import {SearchAdvertiser} from "../../components/common/SearchAdvertiser";
import {toast} from "react-toastify";
import {useForm} from "react-hook-form";
import {createCustomReportsAxios, retrieveCustomReportsList} from "../../services/reports/ReportsAxios";
import {reportsInfoAtom, tokenResultAtom} from "../login/entity/Common";
import {useAtomValue, useSetAtom} from "jotai";
import {useNavigate} from "react-router-dom";
import {createCustomReportsAdminAxios, retrieveCustomReportsAdminList} from "../../services/reports/ReportsAdminAxios";

const indexedColumns = (columns) => {
  return [
    {name:"BY_DAILY", header: "일별", textAlign: 'center', visible: columns.includes('BY_DAILY'), sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_WEEKLY", header: "주별", textAlign: 'center', visible: columns.includes('BY_WEEKLY'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_MONTHLY", header: "월별", textAlign: 'center', visible: columns.includes('BY_MONTHLY') ,sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_ADVERTISE", header: "광고주 명", textAlign: 'center', visible: columns.includes('BY_ADVERTISE') ,sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_CAMPAIGN", header: "캠페인 명", textAlign: 'center', visible: columns.includes('BY_CAMPAIGN'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_PRODUCT", header: "광고 상품", textAlign: 'center', visible: columns.includes('BY_PRODUCT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"BY_TARGETING", header: "타겟팅", textAlign: 'center', visible: columns.includes('BY_TARGETING'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"COUNT_BY_ADVERTISE", header: '광고주 수', textAlign: 'center', visible: columns.includes('COUNT_BY_ADVERTISE'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"TOTAL_EXPOSURE_COUNT", header: "총 노출수", textAlign: 'center', visible: columns.includes('TOTAL_EXPOSURE_COUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"EXPOSURE_COUNT", header: "노출수", textAlign: 'center', visible: columns.includes('EXPOSURE_COUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"TOTAL_CLICK_COUNT", header: "총 클릭수", textAlign: 'center', visible: columns.includes('TOTAL_CLICK_COUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"VALID_CLICK_COUNT", header: "클릭수", textAlign: 'center', visible: columns.includes('VALID_CLICK_COUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"CLICK_RATE", header: "클릭률", textAlign: 'center', visible: columns.includes('CLICK_RATE'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"COST_AMOUNT", header: "비용", textAlign: 'center', visible: columns.includes('COST_AMOUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"CPC", header: "CPC", textAlign: 'center', visible: columns.includes('CPC'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"CONVERSION_PRICE", header: "전환단가", textAlign: 'center', visible: columns.includes('CONVERSION_PRICE'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"CONVERSION_COUNT", header: "전환수", textAlign: 'center', visible: columns.includes('CONVERSION_COUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"CONVERSION_RATE", header: "전환율", textAlign: 'center', visible: columns.includes('CONVERSION_RATE'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"AMOUNT_PURCHASED_AVG", header: "평균구매액", textAlign: 'center', visible: columns.includes('AMOUNT_PURCHASED_AVG'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"SESSION_CONVERSION_AMOUNT", header: "세션 매출", textAlign: 'center', visible: columns.includes('SESSION_CONVERSION_AMOUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"SESSION_CONVERSION_ROAS", header: "세션 ROAS", textAlign: 'center', visible: columns.includes('SESSION_CONVERSION_ROAS'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"DIRECT_CONVERSION_AMOUNT", header: "직접 매출", textAlign: 'center', visible: columns.includes('DIRECT_CONVERSION_AMOUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"DIRECT_CONVERSION_ROAS", header: "직접 ROAS", textAlign: 'center', visible: columns.includes('DIRECT_CONVERSION_ROAS'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    // {name:"EXPOSURE_CONVERSION_AMOUNT", header: "노출 매출", textAlign: 'center', visible: columns.includes('EXPOSURE_CONVERSION_AMOUNT'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    // {name:"EXPOSURE_CONVERSION_ROAS", header: "노출 ROAS", textAlign: 'center', visible: columns.includes('EXPOSURE_CONVERSION_ROAS'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"ROAS", header: "총 ROAS", textAlign: 'center', visible: columns.includes('ROAS'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
    {name:"E_CPM", header: "eCPM", textAlign: 'center', visible: columns.includes('E_CPM'),sortable: false, resizable: false, showColumnMenuTool: false, draggable: false},
  ]
}

export default function CreateReports() {
  const [period, setPeriod] = useState('NONE')
  const [scopes, setScopes] = useState([])
  const [dataItems, setDataItems] = useState([])
  const [columns, setColumns] = useState([])
  const [creativeInfo, setCreativeInfo] = useState({})
  const [reportName, setReportName] = useState('')
  const { register, setError, clearErrors, formState: { errors } } = useForm();
  const tokenResult = useAtomValue(tokenResultAtom)
  const setReportsInfo = useSetAtom(reportsInfoAtom)
  const navigate = useNavigate()
  const [defaultType, setDefaultType] = useState(null)

  useEffect(() => {
    if(tokenResult?.role !== 'NORMAL') {
      setCreativeInfo({
        ...creativeInfo,
        email: tokenResult?.id
      })
    } else {
      setCreativeInfo({
        ...creativeInfo,
        id: tokenResult?.id
      })
    }
    setReportsInfo({
      id: null,
      groupBy: null
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(period === 'NONE' && scopes.length === 0) setColumns([]);
  }, [scopes]);

  /**
   * 광고주 검색
   * @param data
   */
  const handleSearchAdvertiser = (data) => {
    setCreativeInfo(data)
  }
  /**
   * 기간 선택
   * @param item
   */
  const handleAddPeriodItem = (item) => {
    setScopes([])
    setPeriod('NONE')
    setDataItems([])
    setColumns([])
    setPeriod(item)
    setColumns([item])
  }
  /**
   * 기준항목 선택
   * @param item
   */
  const handleAddScopesItem = (item) => {
    if(columns.filter(datum => datum === item).length === 0){
      setScopes(prev => [...prev, item])
      setColumns(prev => [...prev, item])
    } else {
      const newScopesData = scopes.filter(datum => datum !== item)
      const newColumnData = columns.filter(datum => datum !== item)
      setScopes(newScopesData)
      setColumns(newColumnData)
    }
  }
  /**
   * 보고서 항목 선택
   * @param item
   */
  const handleAddReportsItem = (item) => {
    if(dataItems.filter(datum => datum === item).length === 0){
      setColumns(prev => [...prev, item])
      setDataItems(prev => [...prev, item])
    } else {
      const newColumnData = columns.filter(datum => datum !== item)
      const newDataItems = dataItems.filter(datum => datum !== item)
      setColumns(newColumnData)
      setDataItems(newDataItems)
    }
  }
  /**
   * 컬럼 포함 객체 불러오기
   * @param name
   * @returns {boolean}
   */
  const includeItem = (name) => {
    const i = columns.filter((item) => { return item === name });
    return i[0] === name
  }
  /**
   * 보고서 명 인풋
   * @param e
   */
  const handleChangeReportName = (e) => {
    clearErrors('reportName')
    if(reportName.length < 13){
      setReportName(e.target.value)
    }
  }
  /**
   * 보고서 생성
   * @returns {Promise<void>}
   */
  const handleCreateReports = async () => {
    let params;
    if (reportName === '') {
      setError('reportName',{type: 'required', message: '보고서 명을 작성해주세요.'})
    } else if(defaultType === null){
      toast.warning("기준항목을 선택해주세요.")
    } else if (defaultType === 'period' && period === 'NONE') {
      toast.warning("기간별 항목을 선택해주세요.")
    } else if(defaultType === 'scopes' && scopes.length === 0) {
      toast.warning("광고 항목을 선택해주세요.")
    } else if(columns.length < 2){
      toast.warning("보고서 항목을 선택해주세요")
    } else if(dataItems.length === 0){
      toast.warning('데이터 항목을 선택해주세요.')
    } else {
      if(tokenResult.role !== "NORMAL") {
        params = {
          "email": tokenResult.id,
          "reportName" : reportName,
          "groupByPeriod" : defaultType === 'period' ? period : 'NONE',
          "groupByScopes" : defaultType === 'scopes' ? scopes : ['NONE'],
          "columns" :  dataItems
        }
        if(creativeInfo.id !== undefined) {
          params.userId = creativeInfo.id
          params.adverName = creativeInfo.adverName
        }
        createCustomReportsAdminAxios(params).then(() => {
          retrieveCustomReportsAdminList(tokenResult.id).then(response => {
            const data  = response[response.length-1]
            setReportsInfo({id: data.id, groupBy: data.groupByPeriod})
            navigate('/board/customReports')
          })
        })
      } else {
        params = {
          "userId" : creativeInfo.id,
          "name": tokenResult.name,
          "reportName" : reportName,
          "groupByPeriod" : defaultType === 'period' ? period : 'NONE',
          "groupByScopes" : defaultType === 'scopes' ? scopes : ['NONE'],
          "columns" :  dataItems
        }
        if(creativeInfo.id !== null && creativeInfo.id !== undefined) {
          createCustomReportsAxios(params).then(() => {
            retrieveCustomReportsList(tokenResult.id).then(response => {
              const data  = response[response.length-1]
              setReportsInfo({id: data?.id, groupBy: data?.groupByPeriod})
              navigate('/board/customReports')
            })
          })
        }
      }
    }
  }
  /**
   * 광고주 재설정 (리셋)
   */
  const handleClickReset = () => {
    setCreativeInfo({})
  }
  /**
   * 컬럼 초기화
   * @param type
   */
  const handleChangeDefaultColumn = (type) => {
    setDefaultType(type.target.value)
    setScopes([])
    setPeriod('NONE')
    setDataItems([])
    setColumns([])
  }
  return(
    <ReportCreatePage>
      <ReportBoard>
        <ReportPageHeader>
          <div>
            <ReportPageTitle>보고서 생성</ReportPageTitle>
            <ReportPageDescription>조회 기준과 성과 지표를 선택해 필요한 형태의 보고서를 만듭니다.</ReportPageDescription>
          </div>
          {/*<HeaderStepBadge>REPORT BUILDER</HeaderStepBadge>*/}
        </ReportPageHeader>
        <ReportSection>
          <ReportsItemContainer>
            <ReportSelectionHeader>
              <strong>보고서 설정</strong>
              <span>광고주와 보고서명을 입력한 후 보고서 유형과 성과 지표를 설정해 주세요.</span>
            </ReportSelectionHeader>
          <RowSpan>
            <RelativeDiv>
              {tokenResult.role !== 'NORMAL' &&
                <>
                  <Span4>광고주 설정</Span4>
                  <Input
                    style={{width: 300}}
                    {...register("creativeName",{
                      required: {
                        value: creativeInfo.adverName === "",
                        message: '광고주를 선택해주세요'
                      }
                    })}
                    value={creativeInfo.adverName || "광고주 전체"}
                    readOnly
                  />
                  <SearchAdvertiser title={'검색'} onSubmit={handleSearchAdvertiser}/>
                  <ResetButton onClick={handleClickReset}>광고주 전체</ResetButton>
                  <small>* 광고주 설정이 없을 경우 전체 보고서가 생성됩니다.</small>
                </>
              }
              {/*{tokenResult.role === 'NORMAL' &&*/}
              {/*  <>*/}
              {/*    <Span4>광고주</Span4>*/}
              {/*    <HorizontalRule style={{margin: '0 10px'}} />*/}
              {/*    <ColSpan2>{tokenResult.name}</ColSpan2>*/}
              {/*  </>*/}
              {/*}*/}
            </RelativeDiv>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <Span4>보고서 명</Span4>
              <div style={{position: "relative", width: "100%"}}>
                <Input
                  {...register("reportName", {
                    required: {
                      value: reportName === "",
                      message: '보고서 명을 작성해주세요'
                    },
                    value: reportName || "",
                    onChange: handleChangeReportName
                  })}
                  maxLength="13"
                  style={errors.reportName?.ref?.value === "" ? {border:"1px solid red"} : null}
                  placeholder={'보고서 명을 작성해주세요 (최대 13자)'}/>
                {errors.reportName?.ref?.value === "" && <ValidationScript>{errors.reportName.message}</ValidationScript>}
              </div>
            </ColSpan2>
          </RowSpan>
            <RowSpan box={true} column={true}>
              <Row>
                <Span4>보고서 유형</Span4>
              </Row>
              <RelativeDiv>
                <label>
                  <input type="radio" name={'defaultType'} value={'period'} onChange={handleChangeDefaultColumn}/>
                  <span>기간별 보고서</span>
                </label>
                <label>
                  <input type="radio" name={'defaultType'} value={'scopes'} onChange={handleChangeDefaultColumn}/>
                  <span>광고 정보별 보고서</span>
                </label>
              </RelativeDiv>
            </RowSpan>
            {defaultType !== null &&
            <RowSpan box={true} column={true}>
              {defaultType === 'period' &&
                <>
                  <Row>
                    <Span4>기간별 항목</Span4>
                  </Row>
                  <Row>
                    <DefaultItemContainer>
                      <DefaultItemButton
                        active={includeItem('BY_DAILY')}
                        onClick={()=>handleAddPeriodItem('BY_DAILY')}>일별</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('BY_WEEKLY')}
                        onClick={()=>handleAddPeriodItem('BY_WEEKLY')}>주별</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('BY_MONTHLY')}
                        onClick={()=>handleAddPeriodItem('BY_MONTHLY')}>월별</DefaultItemButton>
                    </DefaultItemContainer>
                  </Row>
                  <VerticalRule/>
                </>
              }
              {defaultType === 'scopes' &&
                <>
                  <Row>
                    <ColTitle>광고 정보 항목</ColTitle>
                  </Row>
                  <Row>
                    <DefaultItemContainer>
                      {tokenResult.role === 'NORMAL' &&
                        <>
                          <DefaultItemButton
                            active={includeItem('BY_CAMPAIGN')}
                            onClick={()=>handleAddScopesItem('BY_CAMPAIGN')}>캠페인명</DefaultItemButton>
                          <DefaultItemButton
                            active={includeItem('BY_PRODUCT')}
                            onClick={()=>handleAddScopesItem('BY_PRODUCT')}>광고 상품</DefaultItemButton>
                        </>
                      }
                      {tokenResult.role !== 'NORMAL' &&
                        <>
                          <DefaultItemButton
                            active={includeItem('BY_ADVERTISE')}
                            onClick={()=>handleAddScopesItem('BY_ADVERTISE')}>광고주 명(ID)</DefaultItemButton>
                          <DefaultItemButton
                            active={includeItem('BY_CAMPAIGN')}
                            onClick={()=>handleAddScopesItem('BY_CAMPAIGN')}>캠페인명</DefaultItemButton>
                          <DefaultItemButton
                            active={includeItem('BY_PRODUCT')}
                            onClick={()=>handleAddScopesItem('BY_PRODUCT')}>광고 상품</DefaultItemButton>
                          <DefaultItemButton
                            active={includeItem('BY_TARGETING')}
                            onClick={()=>handleAddScopesItem('BY_TARGETING')}>타겟팅</DefaultItemButton>
                        </>
                      }
                    </DefaultItemContainer>
                  </Row>
                  <VerticalRule/>
                </>
              }
              {(scopes.length !== 0 || period !== 'NONE') &&
                <>
                  <Row>
                    <ColTitle>데이터 항목 (다중선택)</ColTitle>
                  </Row>
                  <Row>
                    <DefaultItemContainer>
                      {tokenResult.role !== 'NORMAL' &&
                        <>
                          <DefaultItemButton
                            active={includeItem('COUNT_BY_ADVERTISE')}
                            onClick={()=>handleAddReportsItem('COUNT_BY_ADVERTISE')}>광고주 수</DefaultItemButton>
                          <DefaultItemButton
                            active={includeItem('TOTAL_EXPOSURE_COUNT')}
                            onClick={()=>handleAddReportsItem('TOTAL_EXPOSURE_COUNT')}>총 노출수</DefaultItemButton>
                        </>

                      }
                      <DefaultItemButton
                        active={includeItem('EXPOSURE_COUNT')}
                        onClick={()=>handleAddReportsItem('EXPOSURE_COUNT')}>노출수</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('TOTAL_CLICK_COUNT')}
                        onClick={()=>handleAddReportsItem('TOTAL_CLICK_COUNT')}>총 클릭수</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('VALID_CLICK_COUNT')}
                        onClick={()=>handleAddReportsItem('VALID_CLICK_COUNT')}>클릭수</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('CLICK_RATE')}
                        onClick={()=>handleAddReportsItem('CLICK_RATE')}>클릭률</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('COST_AMOUNT')}
                        onClick={()=>handleAddReportsItem('COST_AMOUNT')}>비용</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('CPC')}
                        onClick={()=>handleAddReportsItem('CPC')}>CPC</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('CONVERSION_PRICE')}
                        onClick={()=>handleAddReportsItem('CONVERSION_PRICE')}>전환단가</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('CONVERSION_COUNT')}
                        onClick={()=>handleAddReportsItem('CONVERSION_COUNT')}>전환수</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('CONVERSION_RATE')}
                        onClick={()=>handleAddReportsItem('CONVERSION_RATE')}>전환율</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('AMOUNT_PURCHASED_AVG')}
                        onClick={()=>handleAddReportsItem('AMOUNT_PURCHASED_AVG')}>평균구매액</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('SESSION_CONVERSION_AMOUNT')}
                        onClick={()=>handleAddReportsItem('SESSION_CONVERSION_AMOUNT')}>세션 매출</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('SESSION_CONVERSION_ROAS')}
                        onClick={()=>handleAddReportsItem('SESSION_CONVERSION_ROAS')}>세션 ROAS</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('DIRECT_CONVERSION_AMOUNT')}
                        onClick={()=>handleAddReportsItem('DIRECT_CONVERSION_AMOUNT')}>직접 매출</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('DIRECT_CONVERSION_ROAS')}
                        onClick={()=>handleAddReportsItem('DIRECT_CONVERSION_ROAS')}>직접 ROAS</DefaultItemButton>
                      {/*<DefaultItemButton*/}
                      {/*  active={includeItem('EXPOSURE_CONVERSION_AMOUNT')}*/}
                      {/*  onClick={()=>handleAddReportsItem('EXPOSURE_CONVERSION_AMOUNT')}>노출 매출</DefaultItemButton>*/}
                      {/*<DefaultItemButton*/}
                      {/*  active={includeItem('EXPOSURE_CONVERSION_ROAS')}*/}
                      {/*  onClick={()=>handleAddReportsItem('EXPOSURE_CONVERSION_ROAS')}>노출 ROAS</DefaultItemButton>*/}
                      <DefaultItemButton
                        active={includeItem('ROAS')}
                        onClick={()=>handleAddReportsItem('ROAS')}>총 ROAS</DefaultItemButton>
                      <DefaultItemButton
                        active={includeItem('E_CPM')}
                        onClick={()=>handleAddReportsItem('E_CPM')}>eCPM</DefaultItemButton>
                    </DefaultItemContainer>
                  </Row>
                </>
              }
            </RowSpan>
            }
          </ReportsItemContainer>
        </ReportSection>
      </ReportBoard>
      <ReportSummaryAside>
        <SummaryHeader>
          {/*<SummaryEyebrow>REPORT SUMMARY</SummaryEyebrow>*/}
          <SummaryTitle>설정 정보</SummaryTitle>
          <SummaryDescription>현재 입력한 보고서 생성 정보를 확인합니다.</SummaryDescription>
        </SummaryHeader>
        <SummaryBody>
          <SummaryItem>
            <SummaryLabel>광고주</SummaryLabel>
            <SummaryValue title={creativeInfo.adverName || '광고주 전체'}>{creativeInfo.adverName || '광고주 전체'}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>보고서명</SummaryLabel>
            <SummaryValue $empty={!reportName}>{reportName || '미입력'}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>보고서 유형</SummaryLabel>
            <SummaryValue $empty={!defaultType}>{defaultType === 'period' ? '기간별 보고서' : defaultType === 'scopes' ? '광고 정보별 보고서' : '미선택'}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>기준 항목</SummaryLabel>
            <SummaryValue>{period !== 'NONE' ? 1 : scopes.length}개</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>성과 지표</SummaryLabel>
            <SummaryValue>{dataItems.length}개</SummaryValue>
          </SummaryItem>
        </SummaryBody>
        <SummaryGuide>필수 항목을 모두 선택한 후 보고서를 생성해 주세요.</SummaryGuide>
        <ReportActions>
          <CreateReportButton type={'button'} onClick={handleCreateReports}>보고서 생성</CreateReportButton>
        </ReportActions>
      </ReportSummaryAside>
    </ReportCreatePage>
  )
}

const ReportCreatePage = styled.div`
  --report-accent: #f5811f;
  --report-line: #e6e9ed;
  --report-surface: #f5f7f9;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 286px;
  width: 100%;
  align-items: start;
  gap: 22px;

  @media (max-width: 1180px) {
    grid-template-columns: 1fr;
  }
`;

const ReportBoard = styled(Board)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--report-line);
  border-radius: 16px;
  background: var(--report-surface);
  box-shadow: 0 10px 30px rgba(31, 41, 55, 0.07);
`;

const ReportPageHeader = styled.header`
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 30px;
  border-bottom: 1px solid var(--report-line);
  background: linear-gradient(135deg, #ffffff 0%, #fff8f1 100%);
`;

const ReportPageTitle = styled.h2`
  margin: 0 0 6px;
  color: #2f363d;
  font-size: var(--font-size-20);
  font-weight: 800;
`;

const ReportPageDescription = styled.p`
  margin: 0;
  color: #858b91;
  font-size: var(--font-size-13);
  line-height: 1.5;
`;

const HeaderStepBadge = styled.span`
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 11px;
  border: 1px solid #f1d4c2;
  border-radius: 999px;
  background: #fff4e8;
  color: #d96500;
  font-size: var(--font-size-11);
  font-weight: 800;
  letter-spacing: 0.08em;
`;

const ReportSection = styled(BoardSearchResult)`
  margin: 22px 24px 0;
  padding: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.04);

  > ${RowSpan} {
    min-height: 54px;
    align-items: center;
    padding: 12px 14px;
    border-bottom: 1px solid #edf0f2;
  }

  ${Span4} {
    width: 112px;
    min-width: 112px;
    color: #555;
    font-size: var(--font-size-13);
    font-weight: 700;
  }

  ${RelativeDiv} {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  ${ColSpan2} {
    width: 100%;
    padding-left: 0;
  }

  input:not([type="radio"]):not([type="checkbox"]) {
    min-height: 42px;
    padding: 0 12px;
    border: 1px solid #dfe3e6;
    border-radius: 8px;
    background: #fff;
    color: #333;
    font-size: var(--font-size-13);

    &:focus {
      border-color: #f5811f;
      box-shadow: 0 0 0 3px rgba(245, 129, 31, 0.12);
      outline: none;
    }

    &[readonly] {
      border-color: #e6e8ea;
      background: #f6f7f8;
      color: #777;
    }
  }

  button {
    min-width: 82px;
    height: 38px;
    padding: 0 14px;
    border: 1px solid #f1d4c2;
    border-radius: 6px;
    background: #fff8f2;
    color: #d96500;
    font-size: var(--font-size-12);
    font-weight: 700;
    cursor: pointer;

    &:hover {
      border-color: #f5811f;
      background: #fff1e4;
    }
  }

  ${ResetButton} {
    border-color: #d9dde1;
    background: #f7f8f9;
    color: #687078;

    &:hover {
      border-color: #bfc5ca;
      background: #eef0f2;
      color: #41484f;
    }
  }

  small { color: #9299a0; font-size: var(--font-size-11); line-height: 1.5; }
`;

const ReportActions = styled(SubmitContainer)`
  align-items: center;
  justify-content: stretch;
  gap: 10px;
  margin-top: 0;
  padding: 14px 20px;
  border-top: 1px solid var(--report-line);
  background: #fff;

  button {
    width: auto;
    width: 100%;
    min-width: 0;
    height: 44px;
    margin: 0;
    padding: 0 18px;
    border-radius: 9px;
    font-size: var(--font-size-16);
    font-weight: 700;
  }

  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: 1fr;
    padding: 12px;

    button {
      width: 100%;
    }
  }
`;

const CreateReportButton = styled(SubmitButton)`
  min-width: 110px;
  height: 44px;
  padding: 0 18px;
  border: 1px solid #f5811f;
  border-radius: 9px;
  background: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-16);
  font-weight: 700;
  box-shadow: none;

  &:hover { background: #ffe8d2; }
`;

const ReportSummaryAside = styled.aside`
  position: sticky;
  top: 18px;
  overflow: hidden;
  border: 1px solid var(--report-line);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 41, 55, 0.08);

  @media (max-width: 1180px) {
    position: static;
  }
`;

const SummaryHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e8ebee;
  background: linear-gradient(135deg, #fff8f2 0%, #fff 75%);
`;
const SummaryEyebrow = styled.div`
  margin-bottom: 7px;
  color: #f5811f;
  font-size: var(--font-size-11);
  font-weight: 800;
  letter-spacing: 0.12em;
`;
const SummaryTitle = styled.div`
  color: #242a31;
  font-size: var(--font-size-18);
  font-weight: 800;
`;
const SummaryDescription = styled.p`
  margin: 7px 0 0;
  color: #7d858d;
  font-size: var(--font-size-12);
  line-height: 1.5;
`;
const SummaryBody = styled.div`
  padding: 8px 20px;
`;
const SummaryItem = styled.div`
  display: flex;
  min-height: 50px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid #f0f1f2;

  &:last-child { border-bottom: 0; }
`;
const SummaryLabel = styled.span`
  flex: 0 0 auto;
  color: #858c93;
  font-size: var(--font-size-12);
`;
const SummaryValue = styled.strong`
  overflow: hidden;
  color: ${({$empty}) => $empty ? '#a3a8ad' : '#333'};
  font-size: var(--font-size-13);
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const SummaryGuide = styled.div`
  margin: 0 20px 20px;
  padding: 12px;
  border: 1px solid #f1d4c2;
  border-radius: 8px;
  background: #fff8f2;
  color: #8b684c;
  font-size: var(--font-size-11);
  line-height: 1.55;
`;

const ReportsItemContainer = styled.div`
  margin-top: 12px;
  padding: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 9px;
  background: #fafbfc;

  > ${RowSpan} {
    margin-bottom: 10px;
    padding: 16px;
    border: 1px solid #e5e8eb;
    border-radius: 9px;
    background: #fff;
  }

  label {
    display: inline-flex;
    min-height: 40px;
    align-items: center;
    gap: 8px;
    margin-right: 8px;
    padding: 0 13px;
    border: 1px solid #e1e4e7;
    border-radius: 8px;
    background: #fff;
    color: #555;
    font-size: var(--font-size-13);
    font-weight: 600;
    cursor: pointer;
  }

  input[type="radio"] { accent-color: #f5811f; }

  ${ColTitle} {
    color: #555;
    font-size: var(--font-size-13);
    font-weight: 700;
    line-height: 1.5;
  }
`

const ReportSelectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: -16px -16px 16px;
  padding: 15px 16px;
  border-bottom: 1px solid #e3e7ea;
  border-radius: 9px 9px 0 0;
  background: #f9fafb;

  strong {
    color: #333;
    font-size: var(--font-size-15);
    font-weight: 700;
  }

  span {
    color: #888;
    font-size: var(--font-size-12);
    line-height: 1.5;
    text-align: right;
  }

  @media (max-width: 700px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;

    span { text-align: left; }
  }
`;

const DefaultItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: var(--font-size-13);
`

const DefaultItemButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 124px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid ${(props) => props.active ? '#f1b786' : '#e1e4e7'};
  border-radius: 7px;
  background-color: ${(props) => props.active ? '#fff4e8' : '#ffffff'};
  color: ${(props) => props.active ? '#d96500' : '#555'};
  font-weight: ${(props) => props.active ? '700' : '500'};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
  &:hover {
    border-color: #f1b786;
    background-color: #fffaf6;
    transform: translateY(-1px);
  }
  & p {
    padding: 0 20px
  }
`

